import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconFileArrowRight, IconStar } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import type { RecoveryPlanSummary } from '../api';

type RecoveryPlanActionsMenuProps = {
  plan: RecoveryPlanSummary;
  onSetAsDefault: () => void;
  onMoveInvoices: () => void;
};

export const RecoveryPlanActionsMenu = ({
  plan,
  onSetAsDefault,
  onMoveInvoices,
}: RecoveryPlanActionsMenuProps) => {
  const { t } = useTranslation();
  const hasInvoices = plan.invoicesCount > 0;

  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          aria-label={`${t(i18nKeys.FORM.ACTIONS)} ${plan.name}`}
        >
          <IconDots size={16} stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {!plan.isDefault && (
          <Menu.Item leftSection={<IconStar size={16} stroke={1.5} />} onClick={onSetAsDefault}>
            {t(i18nKeys.PLAN.SET_AS_DEFAULT)}
          </Menu.Item>
        )}
        {hasInvoices && (
          <Menu.Item
            leftSection={<IconFileArrowRight size={16} stroke={1.5} />}
            onClick={onMoveInvoices}
          >
            {t(i18nKeys.PLAN.MOVE_INVOICES)}
          </Menu.Item>
        )}
        {plan.isDefault && !hasInvoices && (
          <Menu.Item disabled>{t(i18nKeys.NO_AVAILABLE_ACTIONS)}</Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
